import { CarouselHeader } from '@/ui/components/carouselHeader/CarouselHeader';
import { Container } from '@/ui/components/container/Container';
import {
  CarouselHandle,
  FullWidthCarousel,
  FullWidthCarouselProps,
} from '@/ui/components/fullWidthCarousel/FullWidthCarousel';
import { Link } from 'gatsby';
import * as styles from './ProjectsFullWidthCarousel.module.scss';
import * as React from 'react';
import { routes } from '@/routes/routes';

export const ProjectsFullWidthCarousel = ({
  items,
  className,
}: {
  items: FullWidthCarouselProps['items'];
  className?: string;
}) => {
  const carouselRef = React.useRef<CarouselHandle | null>(null);

  return (
    <div className={className}>
      <Container>
        <div className={styles.projectsCarousel__header}>
          <CarouselHeader className={styles.projectsCarousel__headerLeft}>
            <CarouselHeader.Title>{items.length > 1 ? 'Featured projects' : 'Featured project'}</CarouselHeader.Title>
            {items.length > 1 ? (
              <CarouselHeader.Navigation
                onPrevClick={() => carouselRef.current?.prev()}
                onNextClick={() => carouselRef.current?.next()}
              />
            ) : null}
          </CarouselHeader>
          <Link to={routes.caseStudies} className={styles.projectsCarousel__link}>
            See all projects
          </Link>
        </div>
      </Container>
      <FullWidthCarousel items={items} ref={carouselRef} />
      <Container>
        <Link to={routes.caseStudies} className={styles.projectsCarousel__bottomBtn}>
          See all projects
        </Link>
      </Container>
    </div>
  );
};
